module.exports = __webpack_public_path__ + "static/img/menage3.4c2a3bcc.png";